import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_8k2kgprutm: FaireCollectionEntity = {
  token: "pbc_8k2kgprutm",
  type: "collection",
  name: "In-Stock Organic Woven Baby Clothes",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8e515cbd7ae33c5e33e215f162b4df223f01333df8f6b70bcb347d05f8be0c0.jpeg",
  itemCount: 117,
  description:
    "Discover Viverano's In-Stock Organic Woven Baby Clothes, ready to ship. Crafted from premium organic cotton with soft, breathable fabrics and heirloom-inspired details. Ethically made in India and thoughtfully designed in the USA.",
  brandToken: "b_7fghelgl",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T04:59:21.045Z",
    importedBy: "entity-db-import-collections",
  },
};
